import { render, staticRenderFns } from "./SmileSelector.vue?vue&type=template&id=7663d970&scoped=true"
import script from "./SmileSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmileSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SmileSelector.vue?vue&type=style&index=0&id=7663d970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7663d970",
  null
  
)

export default component.exports